import { app } from '@/main'
import { findCookieByNameWithPrefix, deleteCookieByName } from '@/utils/CookiesUtil'
import { routeFromRoot } from '@/services/routeService'

function getCookieNamePrefix() {
  return window.COOKIES_NAME_PREFIX
}
function getSystemLangName() {
  return `${getCookieNamePrefix()}sts-lang`
}

function getUserBasicDataFromCookie() {
  try {
    const ENCRYPTED_BASE64_DATA = findCookieByNameWithPrefix("STS_USER")
    if (!ENCRYPTED_BASE64_DATA) throw new Error("No STS_USER valid data found!")
    const DESCRYPTED_DATA = atob(ENCRYPTED_BASE64_DATA)
    return JSON.parse(DESCRYPTED_DATA)
  }
  catch(e) {
    removeUserToken()
    routeFromRoot("login")
    app.$failedDialog.open(null, "dialogs.messages.failed.noLongerLoggedInTheSystem", null)
  }
}

export function getUserIdentification() {
  return getUserBasicDataFromCookie().identification
}
export function getUserToken() {
  return getUserBasicDataFromCookie().token
}
export function getUserRole() {
  return getUserBasicDataFromCookie().permissions[0]
}
export function isUserLogged() {
  const logged = findCookieByNameWithPrefix("STS_LOGGED")
  return typeof(logged) === "string" && logged.toLowerCase() === "true"
}
export function removeUserToken() {
  deleteCookieByName("STS_LOGGED")
  deleteCookieByName("STS_USER")
  app.$auth.process()
}
export function selectLanguage(lang) {
  const itemName = getSystemLangName()
  if (lang.toLowerCase() === 'es' || lang.toLowerCase() === 'en') localStorage.setItem(itemName, lang)
  else console.error("There no such language!")
}
export function getSelectedLanguage() {
  const itemName = getSystemLangName()
  if (localStorage.getItem(itemName) === null) {
    return 'en'
  }
  else return localStorage.getItem(itemName)
}
export function getSelectedLanguageFromUrl() {
  return window.location.hash.substr(2, 2)
}
export function isLanguageSp() {
  return getSelectedLanguage().toLowerCase() === 'es'
}
export function isLanguageEn() {
  return getSelectedLanguage().toLowerCase() === 'en'
}